import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { styled } from '../../utils';
import { Card } from '../Card';
import { FormGrid } from '../FormGrid';
export const Tile = forwardRef(function Paper(props, _ref) {
    const { children, handleClick, ...otherProps } = props;
    return (_jsx(Card, { onClick: handleClick, sx: { padding: '16px' }, children: _jsx(RootStyled, { rowGap: 2, ...otherProps, children: children }) }));
});
const RootStyled = styled(FormGrid)(() => ({
    justifyContent: 'center',
    cursor: 'pointer',
    opacity: 1,
}));
